import React, { FC, useEffect } from "react";
import TagManager from "react-gtm-module";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import Castle from "Shared/Analytics/CastleProvider";
import * as Sentry from "@sentry/react";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";

type Props = {
  gtmId: string;
};

const AnalyticsConfig: FC<Props> = ({ children, gtmId }) => {
  const { currentProvider, employer } = usePartnerConfig();

  AmplitudeProvider.setEmployerProps({
    providerId: currentProvider?.id,
    providerName: currentProvider?.name,
    employerId: employer.id,
  });

  useEffect(() => {
    if (currentProvider && currentProvider.id) {
      const tagManagerArgs = {
        gtmId,
        dataLayer: {
          providerId: currentProvider.id,
        },
      };
      TagManager.initialize(tagManagerArgs);
      Castle.identify(currentProvider.id);
      Sentry.setContext("Partner Info", {
        providerId: currentProvider.id,
        employerId: employer.id,
      });
      Castle.trackPageView();
    }
  }, [currentProvider, employer, gtmId]);

  return <>{children}</>;
};

export default AnalyticsConfig;
